import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-congres-virtuel-mentions-legales',
  templateUrl: './congres-virtuel-mentions-legales.component.html',
  styleUrls: ['./congres-virtuel-mentions-legales.component.scss']
})
export class CongresVirtuelMentionsLegalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
